module.exports = "<div class=\"row\">\n  <div class=\"col s12 l6\">\n    <h6 class=\"center big-text\">Utilisée / Disponible</h6>\n\n    <canvas id=\"areaPie\"\n      class=\"chart chart-doughnut\"\n      chart-data=\"areaPieData\"\n      chart-labels=\"areaPieLabels\">\n    </canvas>\n  </div>\n\n  <div class=\"col s12 l6\">\n    <h6 class=\"center big-text\">Détail par zone</h6>\n\n    <canvas id=\"areasPie\"\n      class=\"chart chart-doughnut\"\n      chart-data=\"areasPieData\"\n      chart-labels=\"areasPieLabels\">\n    </canvas>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/stat/myAreaPie.html
// module id = 1275
// module chunks = 0